<template>
	<div>
		<b-breadcrumb>Calls</b-breadcrumb>
		<b-alert :show="!!error" variant="danger">{{error&&(error.error||error.toString())}}</b-alert>
		<b-table small striped hover :items="calls" :busy="loading>0" :fields="['title','created_at','category',{ label: '', key: 'actions', thClass: 'text-right', tdClass: 'text-right'}]">
			<template #head(actions)>
				<b-button @click="openCallEditModal()" variant="success" size="sm"><b-icon icon="plus"></b-icon> Create call</b-button>
			</template>
			<template #foot(actions)>
				<b-button @click="openCallEditModal()" variant="success" size="sm"><b-icon icon="plus"></b-icon> Create call</b-button>
			</template>
			<template #cell(title)="data">
				<a :href="`/user/${encodeURIComponent(user.username)}/call/${encodeURIComponent(data.item.id)}`">{{data.value}}</a>
			</template>
			<template #cell(actions)="data">
				<b-button-group size="sm">
					<b-button @click="openCallEditModal(data.item.id)" v-b-tooltip.hover.left title="Edit command"><b-icon icon="pencil-fill"></b-icon></b-button>
					<b-button variant="danger" @click="openCallDeleteModal(data.item.id)" v-b-tooltip.hover.right.v-danger title="Delete command"><b-icon icon="trash"></b-icon></b-button>
				</b-button-group>
			</template>
		</b-table>
		<b-modal ref="callEditModal" :title="`Edit call`" :busy="callLoading > 0">
			<b-form @submit.stop.prevent="saveCall(); return false" id="callEditForm" v-if="curCall">
				<b-form-group label="Title">
					<b-form-input v-model="curCall.title" maxlength="200" required></b-form-input>
				</b-form-group>
			</b-form>
			<b-alert variant="danger" :show="!!callError">{{callError}}</b-alert>
			<template #modal-footer="{ ok, cancel }">
				<b-spinner v-show="callLoading>0" small label="Spinning"></b-spinner>
				<b-button size="sm" variant="success" type="submit" form="callEditForm">
					Save
				</b-button>
				<b-button size="sm" @click="cancel()">
					Cancel
				</b-button>
			</template>
		</b-modal>
	</div>
</template>

<script>
import util from '../util';

export default {
	data() { return {
		calls: [],
		error: null,
		loading: 0,
		callError: null,
		callLoading: 0,
		curCall: null,
		user: null,
	}},
	created() {
		this.$api.get('userData').then(user => this.user = user, err => console.error(err));
		this.loadCalls();
	},
	methods: {
		async loadCalls() {
			try {
				this.loading++;
				this.calls = (await this.$api.get('calls')).map(c => ({ ...c, created_at: util.relativeDate(c.created_at) }));
			} catch(e) {
				console.error('Loading calls', e);
				this.error = e;
			} finally {
				this.loading--;
			}
		},

		async openCallEditModal(id) {
			try {
				this.callError = null;
				this.callLoading++;
				this.curCall = id ? await this.$api.get(`call/${encodeURIComponent(id)}`) : { title: '' };
				this.$refs.callEditModal.show();
			} catch(e) {
				console.error('Opening call edit modal', e);
				this.callError = e;
			} finally {
				this.callLoading--;
			}
		},

		async saveCall() {
			try {
				this.callLoading++;
				this.callError = null;
				await this.$api.post('call', this.curCall);
				this.$refs.callEditModal.hide();
				this.curCall = null;
				await this.loadCalls();
			} catch(e) {
				this.callError = e;
				console.error('Error saving item:', e);
			} finally {
				this.callLoading--;
			}
		},
	}
};
</script>
